import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        {/* Top section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                CSSBuy Spreadsheet
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed mb-4">
              Seu guia completo para CSSBuy Spreadsheet. Planilhas, tutoriais, comparações e dicas para comprar da China com segurança e economia.
            </p>
            <p className="text-foreground-400 text-xs">
              Este site não é afiliado oficialmente ao CSSBuy. Recurso independente de informações.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm uppercase tracking-wider">
              Links Rápidos
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-spreadsheet-o-que-e" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                  O que é CSSBuy Spreadsheet
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-guia-completo" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                  Guia Completo
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-seguro-e-confiavel" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                  Segurança CSSBuy
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm uppercase tracking-wider">
              Categorias
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-300 hover:text-background-50 text-sm transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-accent-400 hover:text-accent-300 text-sm transition-colors"
                >
                  Ver Todas Categorias →
                </a>
              </li>
            </ul>
          </div>

          {/* Articles */}
          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm uppercase tracking-wider">
              Artigos
            </h4>
            <ul className="space-y-2.5">
              {articles.map((article) => (
                <li key={article.id}>
                  <Link
                    to={`/${article.id}`}
                    className="text-foreground-300 hover:text-background-50 text-sm transition-colors"
                  >
                    {article.title}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 mt-2 px-4 py-2 rounded-full bg-accent-500 text-background-50 text-sm font-medium cursor-pointer hover:bg-accent-600 transition-colors whitespace-nowrap"
                >
                  Acessar Site Principal
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} CSSBuy Spreadsheet. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-400 hover:text-background-50 text-xs transition-colors"
            >
              Política de Privacidade
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-400 hover:text-background-50 text-xs transition-colors"
            >
              Termos de Uso
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-400 hover:text-background-50 text-xs transition-colors"
            >
              Contato
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}